import { c as _c } from "react/compiler-runtime";
import HomeIcon from '@mui/icons-material/HomeOutlined';
export const Home = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <HomeIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};